import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import { SimpleActionCreator, ToggleAllCheckboxesStore } from '../../helpers/types';

@Component({
  selector: 'app-toggle-all-checkboxes',
  templateUrl: './toggle-all-checkboxes.component.html',
  styleUrls: ['./toggle-all-checkboxes.component.scss']
})
export class ToggleAllCheckboxesComponent {
  @Input() action: SimpleActionCreator<{ checked: boolean }>;

  constructor(private store: Store<ToggleAllCheckboxesStore>) {}

  toggleAllCheckboxes(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.store.dispatch(this.action({ checked }));
  }
}
